import firebase from '@firebase/app';
import { getAppId, getUserCode, versionCheckFunction } from './apiConfig';
import ReactGA from 'react-ga';
import * as Sentry from '@sentry/react';
declare global {
  interface Window {
    gtag?: Function;
  }
}
declare let operatorapp: any;
export const sendToGA = (action: string, label: string, category: string) => {
  try {
    ReactGA.event({
      category,
      action,
      label,
    });
  } catch (error) {
    console.log('tracking error gtag', error);
  }
};
export const trackPageview = () => {
  try {
    ReactGA.event({
      category: 'event',
      action: 'page_view',
    });
  } catch (error) {
    console.log('tracking error gtag 2', 'page_view', error);
  }
};
export const isAppEventAllowed = () => {
  const isAppEventEnabled =
    typeof operatorapp !== 'undefined' &&
    operatorapp !== null &&
    operatorapp &&
    typeof operatorapp.expenseManagerEvent === 'function' &&
    operatorapp.expenseManagerEvent !== 'undefined';
  return isAppEventEnabled && webviewEventEnabled();
};
const webviewEventEnabled = () => {
  let xAppVersion = sessionStorage['x-app-version:'];
  return versionCheckFunction(xAppVersion, '13.7.0');
};
export const sendEvent = (eventName: any, payload?: any, sendUserCode = false) => {
  let payloadData = payload ? payload : {};
  payloadData = { ...payloadData };
  if (isAppEventAllowed()) {
    payloadData.event_name = eventName;
    payloadData.screen_name = 'web_' + payload.screen_name;
    const { miscellaneous, ...restPayload } = payloadData;
    if (miscellaneous) {
      try {
        return sendEventToAndroid({ ...restPayload, miscellaneous: parseMiscellaneous(JSON.parse(miscellaneous)) });
      } catch (err) {
        Sentry.captureException(err);
        return sendEventToAndroid(payloadData);
      }
    } else {
      return sendEventToAndroid(payloadData);
    }
  }
  if (sendUserCode) {
    firebase.analytics().setUserProperties({ operator_code: getUserCode() });
  }
  firebase.analytics().logEvent(eventName, payloadData);
};

const stringifyValue = (value: any): any => {
  if (typeof value === 'object') {
    if (Array.isArray(value)) {
      if (!value.length) return 'null';
      return value.map((item) => stringifyValue(item)).join(',');
    } else {
      return parseMiscellaneous(value);
    }
  } else {
    return value.toString();
  }
};

export const parseMiscellaneous = (obj: any) => {
  if (obj === null || obj === undefined) return 'null';
  return Object.entries(obj)
    .map(([key, value]) => `${key} : ${stringifyValue(value)}`)
    .join(' :: ');
};

export const sendEvent2 = (eventName: any, payload?: any, sendUserCode = false) => {
  let payloadData = payload ? payload : {};
  payloadData = { ...payloadData };
  let userData = {};
  if (sendUserCode) {
    userData = {
      operator_code: getUserCode(),
    };
  }
  if (isAppEventAllowed()) {
    payloadData.event_name = eventName;
    payloadData.screen_name = 'web_' + payloadData.screen_name;
    const { miscellaneous, ...restPayload } = payloadData;
    if (miscellaneous) {
      try {
        return sendEventToAndroid({ ...restPayload, miscellaneous: parseMiscellaneous(JSON.parse(miscellaneous)) });
      } catch (err) {
        Sentry.captureException(err);
        return sendEventToAndroid(payloadData);
      }
    } else {
      return sendEventToAndroid(payloadData);
    }
  }
  firebase.analytics().logEvent(eventName, payloadData);
  firebase.analytics().setUserProperties(userData);
};

export const sendEventToAndroid = (parameters: any) => {
  try {
    if (operatorapp && typeof operatorapp !== 'undefined' && operatorapp !== null) {
      const {
        event_name,
        event_action,
        event_category,
        screen_name,
        miscellaneous,
        target_product,
        entity,
        vehicle_id,
      } = parameters;
      const parametersToSend = {
        event_name,
        event_action,
        event_category,
        screen_name,
        miscellaneous,
        target_product,
        entity,
        ...(vehicle_id ? { vehicle_id } : {}),
      };
      operatorapp.expenseManagerEvent(JSON.stringify(parametersToSend));
    } else {
      console.log('could not send event1', parameters);
    }
  } catch (error) {
    console.log(error, '--ERROR--');
    Sentry.captureException(error);
    // console.log('could not send event', parameters);
  }
};

export interface Analytics {
  event_name: string;
  event_action: string;
  event_category: string;
  screen_name: string;
  miscellaneous?: string;
  target_product?: string;
  sendUserCode?: boolean;
  entity?: string;
}
